import React, { useState, useEffect, useRef } from 'react'
import { ScrollView, StyleSheet, Text, TouchableOpacity, View } from 'react-native'
import { PerfectStoreTagsModel } from './models/StoreDetailModel'
import theme from '../../../theme'
import styles from './FormStepsStyles'
import { FieldsView } from './FieldsView'
import { schedulesServices } from '../../../database/schedules.database'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { useStepsDistributor } from '../../redux/zustand/stepsDistributorStore'

export const FormSteps = ({ fields, store_id, schedule_id, closeBottomSheet, saveSteps, saveItemSteps, option }) => {
    const { languageFile } = getLanguage()
    const getStepsDistri = useStepsDistributor((state) => state.steps)
    let buton_send_active = !saveSteps || (saveSteps && getStepsDistri.length == fields.length) ? false : true

    return (
        <View style={styles.container}>
            <FieldsView
                fields={fields}
                form_id={null}
                schedule_id={null}
                store_id={null}
                answerProp={null}
                closeBottomSheet={() => {}}
                saveItemSteps={saveItemSteps}
                checkComplete={() => {}}
                keyboardHiddenState={null}
                onFocus={() => {}}
                activeInputId={null}
            />
            <View style={styles.buttonContainer}>
                <TouchableOpacity
                    style={!buton_send_active ? styles.mainButton : styles.mainButtonDisabled}
                    onPress={() => saveSteps(getStepsDistri, option)}
                    disabled={buton_send_active}
                >
                    <Text style={!buton_send_active ? styles.mainButtonText : styles.mainButtonTextDisabled}>{languageFile.send}</Text>
                </TouchableOpacity>
                {saveSteps && (
                    <TouchableOpacity style={styles.borderButton} onPress={() => closeBottomSheet(true)}>
                        <Text style={styles.borderButtonText}>{languageFile.close}</Text>
                    </TouchableOpacity>
                )}
            </View>
        </View>
    )
}
